import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Grid,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import { useTheme } from '@mui/system';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import ApiHelper from 'utils/apiHelper';
import { gridSpacing } from 'utils/constants';
import ReportFileExports from 'components/Reports/FileExports';

const DeviceTimeDevicesDialog = ({ onClose, startDate, groupId, groupsData, selectedStatements }) => {
    const theme = useTheme();
    const [devicesData, setDevicesData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtersData, setFiltersData] = useState([]);

    useEffect(() => {
        setLoading(true);
        ApiHelper.post('/api/reports/device_vs_time_devices/', {
            the_date: startDate,
            group_id: groupId === 0 ? '' : groupId.toString(),
            statement: selectedStatements.length > 0 ? selectedStatements : []
        })
            .then((res) => {
                setLoading(false);
                setDevicesData(res.data);
                toast.success('Successfully done');
                let groupName = 'Any';
                for (let i = 0; i < groupsData.length; i++) {
                    if (groupsData[i].id === groupId) {
                        groupName = groupsData[i].name;
                    }
                }
                const temp = [
                    { label: 'Date', value: startDate },
                    { label: 'Group Name', value: groupName }
                ];
                setFiltersData(temp);
            })
            .catch(() => {
                setLoading(false);
                toast.warning('There is no devices data');
            });
    }, [startDate, groupId, groupsData, selectedStatements]);

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Show Device vs Time Devices</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <Grid container spacing={gridSpacing}>
                        {devicesData.length > 0 && (
                            <Grid item xs={12}>
                                <ReportFileExports
                                    elementId="detailedDevicesData"
                                    reportTitle="Device vs Time Devices"
                                    downloadFileName={'device_vs_time_devices'}
                                    downloadFileOption="all"
                                    data={devicesData}
                                    headers={[
                                        { label: 'Date', key: 'date' },
                                        { label: 'Device Name', key: 'name' },
                                        { label: 'MAC Address', key: 'mac' },
                                        { label: 'IP Address', key: 'ipv4' }
                                    ]}
                                    filtersData={filtersData}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Paper sx={{ overflowX: 'auto' }}>
                                {loading === true ? (
                                    <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}>
                                        Please wait...
                                    </Typography>
                                ) : devicesData.length === 0 ? (
                                    <Typography sx={{ textAlign: 'center', mt: 3 }} color={theme.palette.secondary.main}>
                                        No data to show the devices data
                                    </Typography>
                                ) : (
                                    <Table id="detailedDevicesData">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Date</TableCell>
                                                <TableCell>Device Name</TableCell>
                                                <TableCell>MAC Address</TableCell>
                                                <TableCell>IP Address</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {devicesData.map((data, key) => (
                                                <TableRow key={key}>
                                                    <TableCell>{startDate}</TableCell>
                                                    <TableCell>{data.name}</TableCell>
                                                    <TableCell>{data.mac}</TableCell>
                                                    <TableCell>{data.ipv4}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                )}
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                {loading === false && (
                    <Button onClick={onClose} color="primary" variant="contained">
                        OK
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

DeviceTimeDevicesDialog.propTypes = {
    onClose: PropTypes.func,
    startDate: PropTypes.string,
    groupId: PropTypes.number,
    groupsData: PropTypes.array,
    selectedStatements: PropTypes.array
};

export default DeviceTimeDevicesDialog;
